<section class="messenger-label__container flex column align-center">
  <div *ngIf="bookingStatusLabel" class="messenger-label__booking-status">{{ bookingStatusLabel }} ·</div>
  <app-date-time-label [dateTime]="dateTime"></app-date-time-label>
</section>
